const style = {
  teamModalPaper: {
    width: 750,
    minHeight: 500,
    maxHeight: 650,
  },
};

export default style;
